import type { EstadoInvitacion } from '@eventos-cien/shared';

const ESTILOS: Record<EstadoInvitacion, { texto: string; clase: string }> = {
  disponible: { texto: 'Disponible', clase: 'bg-texto/10 text-texto/60' },
  en_mano: { texto: 'En mano', clase: 'bg-sky-50 text-sky-700' },
  entregada: { texto: 'Enviada', clase: 'bg-sky-50 text-sky-700' },
  registrada: { texto: 'Registrada', clase: 'bg-emerald-50 text-emerald-700' },
  anulada: { texto: 'Anulada', clase: 'bg-red-50 text-red-600' },
};

/** Pastilla de color para el estado crudo de una invitacion — evita que el asesor/admin tenga que leer texto tecnico. */
export function EstadoInvitacionBadge({ estado }: { estado: EstadoInvitacion }) {
  const { texto, clase } = ESTILOS[estado];
  return (
    <span className={['inline-flex w-fit rounded-full px-2 py-0.5 text-[11px] font-medium', clase].join(' ')}>
      {texto}
    </span>
  );
}
